import enCommon from './en/common';
import enPages from './en/pages';
import jaCommon from './ja/common';
import jaPages from './ja/pages';
import koCommon from './ko/common';
import koPages from './ko/pages';
import zhTWCommon from './zh-TW/common';
import zhTWPages from './zh-TW/pages';

const messages: Record<string, Record<string, unknown>> = {
  en: {
    translation: enCommon,
    pages: enPages,
  },
  ja: {
    translation: jaCommon,
    pages: jaPages,
  },
  ko: {
    translation: koCommon,
    pages: koPages,
  },
  'zh-TW': {
    translation: zhTWCommon,
    pages: zhTWPages,
  },
};

export default messages;